import {GaugedInvestment} from './gauged-investment.model';

export class SelectedInvestment {
    public amount: number;
    public gaugedInvestment: GaugedInvestment;

    public static from(selectedInvestmentJson: any): SelectedInvestment {
        const selectedInvestment = new SelectedInvestment();
        Object.assign(selectedInvestment, selectedInvestmentJson);
        return selectedInvestment;
    }
}